import * as React from "react";
import navigateTo from "../utils/navigate_to";

import Heading from "../components/Heading";

interface GridItemProps {
	children: any;
	style?: React.CSSProperties;
	onClick: () => void;
}

const GridItem = (props: GridItemProps) => (
	<div
		style={{
			backgroundColor: "white",
			maxWidth: 600,
			margin: "1rem",
			padding: "1rem",
			boxSizing: "border-box",
			borderRadius: 10,
			flex: 1,
			...(props.style || {}),
		}}
		onClick={props.onClick}
	>
		{props.children}
	</div>
);

interface GridProps {
	children: any;
}

const Grid = (props: GridProps) => (
	<div
		style={{
			minHeight: 100,
			margin: "1.61rem",
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap",
			justifyContent: "center",
			boxSizing: "border-box",
		}}
	>
		{props.children}
	</div>
);

interface PageCell {
	title: string;
	description: string;
	iconSrc: string;
	url: string;
}

const PageCell = (props: PageCell) => (
	<GridItem style={{ cursor: "pointer" }} onClick={() => navigateTo(props.url)}>
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					alignItems: "center",
					width: 150,
					marginBottom: "1.61rem",
				}}
			>
				<img src={props.iconSrc} style={{ marginBottom: 0, height: 125 }} />
			</div>
			<div
				style={{
					justifyContent: "center",
					display: "flex",
					flexDirection: "column",
					flex: 1,
				}}
			>
				<h2
					style={{
						textAlign: "center",
						marginBottom: "0.5rem",
					}}
				>
					{props.title}
				</h2>
				<p
					style={{
						textAlign: "center",
						marginBottom: 0,
					}}
				>
					{props.description}
				</p>
			</div>
		</div>
	</GridItem>
);

const PAGES = [
	{
		title: "Q & A on Stack Overflow",
		description: "Ask questions about our platform on Stack Overflow",
		url: "https://stackoverflow.com/tags/vatom",
		iconSrc: require("../res/support/stackoverflow.svg"),
	},
	{
		title: "Email us",
		description: "Contact us via email",
		url: "mailto:support@blockv.io",
		iconSrc: require("../res/support/email.svg"),
	},
	{
		title: "Find us on GitHub",
		description: "Download our SDKs and other source code on GitHub",
		url: "https://github.com/BLOCKvIO",
		iconSrc: require("../res/support/github.svg"),
	},
];

const SupportPage = () => (
	<div>
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				paddingTop: "calc(60px + 1.61em)",
			}}
		>
			<Heading>Support</Heading>

			<Grid>
				{PAGES.map(page => (
					<PageCell
						key={page.title}
						title={page.title}
						description={page.description}
						iconSrc={page.iconSrc}
						url={page.url}
					/>
				))}
			</Grid>
		</div>
	</div>
);

export default SupportPage;



// WEBPACK FOOTER //
// ./src/pages/support.tsx